import dynamic from 'next/dynamic'
import Head from 'next/head'


import firebase_app from '../../lib/firebaseConfig'

import { getFirestore, collection, query, where, getDocs, orderBy } from "firebase/firestore";
//import prisma from '../../lib/prismaConnection'
import { descripion } from '../../constants/seo'
import LoadingComponent from '../../components/shared/loadingComponent'

const USpaperMoneyHero = dynamic(() => import('../../components/pagesCpmponents/usPaperMoney/usPaperMoneyHerro'), {
    loading: () => <LoadingComponent />,
})
const CardCurrentItems = dynamic(() => import('../../components/cardsCoins/cardCurrentItems'), {
    loading: () => <LoadingComponent />,
})
const PagaeLoad = dynamic(() => import('../../components/animations/pageLoad'))


const db = getFirestore(firebase_app);
export async function getStaticProps() {

   // let itemsArray1 = [];

    //try {
    //    await main()
    //        .then(e => {
    //            const arr = new Promise((resolve) => {
    //                itemsArray1 = e
    //                resolve()
    //            })
    //            arr.catch(e => console.log(e))
    //        })
    //        .then(async () => {
    //            await prisma.$disconnect()
    //        })
    //        .catch(async (e) => {
    //            console.error(e)
    //            await prisma.$disconnect()
    //        })
    //    ///88888888888 main 8888888888888
    //    async function main() {
    //        const items = await prisma.items.findMany({
    //            where: {
    //                uspaper: 'y',
    //                archive: 'n'
    //            },
    //            orderBy: [{
    //                country: 'asc',
    //            },
    //            {
    //                year: 'asc',
    //            },
    //            ],
    //            select: {
    //                id: true,
    //                image1: true,
    //                image2: true,
    //                title: true,
    //                price: true,
    //            },
    //        })
    //        return items
    //    }

    //    let itemsArray = [];

    //    if (itemsArray1 !== undefined && itemsArray1 !== null) {

    //        itemsArray = await JSON.stringify(itemsArray1, (_, id) => typeof id === 'bigint' ? id.toString() : id)

    //    }
    //    return {
    //        props: { itemsArray }
    //    }
    //} catch (e) {

    //    return {
    //        props: { itemsArray: [] }
    //    }
    //}



    try {
        const citiesRef = collection(db, "coinData");

        const q = query(citiesRef, where("uspaper", "==", "y"), where("archive", "==", "n"), orderBy("country"), orderBy("year"));
        const querySnapshot = await getDocs(q);
        let itemsArray1 = []
        await querySnapshot.forEach((doc) => {
            itemsArray1.push({ ...doc.data() })
        });
        let itemsArray = JSON.stringify(itemsArray1)
        return {
            props: { itemsArray }
        }
    } catch (e) {
        //  console.log('US paper money check error: '+e)
        return {
            props: { itemsArray: [] }
        }
    }
}


export default function USpaperMoneyPage(props) {

    const title = `US Paper Money | Fl Gold Coin Exchange`

    return (<div className='homeBgImg'>
        <Head>
            <title>{title}</title>
            <meta name="description" content={descripion} />
            <meta keywords="US Paper Currency,the US paper money, Rare U.S. Paper Currency" />
            <link rel="canonical" href={`${process.env.siteUrl}/USpaperMoney`} />
            <meta property="og:url" content={`${process.env.siteUrl}/USpaperMoney`} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={descripion} />
            <meta property="og:image" content={`${process.env.siteUrl}/images/facebook.jpg`} />
            <meta name="AdsBot-Google" content="index" />
            <meta name="robots" content="index, follow" />
        </Head>
        <PagaeLoad>
            <USpaperMoneyHero />
            <CardCurrentItems
                coinLink={'USpaperMoney'}
                data={props}
            />
        </PagaeLoad>
    </div>
    )
}